import React from 'react';
import { connect } from 'react-redux';
import ViaplayLiveFeed from './ViaplayLiveFeed';
import ViasportLiveFeed from './ViasportLiveFeed';
import PageWithoutSidebars from '../Page/PageWithoutSidebars.jsx';
import translatedRoutes from '../../config/translatedRoutes';
import LiveMeta from './LiveMeta';

const mapStateToProps = state =>({
  language: state.language,
  country: state.country,
  articlePageRoute: translatedRoutes[state.country].ArticlePage,
  broadcastAreaData: state.broadcastAreaData,
});

@connect(mapStateToProps)
export default class LiveArea extends React.PureComponent {

  render() {
    const { language, country, articlePageRoute, broadcastAreaData } = this.props;
    const { viaplayLiveStreams, viasportLiveStreams } = broadcastAreaData;

    return (
      <PageWithoutSidebars>
        <div className="live-area">
          <LiveMeta />
          <ViaplayLiveFeed liveStreams={viaplayLiveStreams} language={language} country={country} />
          <ViasportLiveFeed liveStreams={viasportLiveStreams} language={language} country={country} articlePageRoute={articlePageRoute} />
        </div>
      </PageWithoutSidebars>
    );
  }
}

LiveArea.propTypes = {
  language: React.PropTypes.string,
  country: React.PropTypes.string,
  articlePageRoute: React.PropTypes.object,
  broadcastAreaFeed: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/Sidebar/LiveArea.jsx